export default __webpack_public_path__ + "static/media/arrow-right.7f62c2c1.svg";